// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__XIHYR","sidebarContainer":"style_sidebarContainer__VedYY","mainContent":"style_mainContent__n4bDC"};